import { TransportCost } from "./transport-cost.model";

export class EnergyTransportCost {
	electric: TransportCost;
	diesel: TransportCost;
	gas: TransportCost;
	electricComp: TransportCost;
}
